import { IconButton } from '@shipt/design-system-buttons'
import { CarouselSection } from '@shipt/design-system-carousel'
import { ArrowRightIcon } from '@shipt/design-system-icons'
import { Body } from '@shipt/design-system-typography'
import { getHeadingElement } from '@/features/shared/utils/getHeadingElement'
import { type StoresCarouselHeaderProps } from '@/features/cms/components/CMS/components/BrandAmplification/StoresCarouselBase'

const ViewAllIcon = ({ onClick }: { onClick: (e: React.MouseEvent) => void }) => (
  <IconButton
    onClick={onClick}
    aria-label="View all stores"
    variant="tertiary"
    icon={ArrowRightIcon}
    size="sm"
    className="tablet-button"
  />
)

export const StoresCarouselHeader = ({
  heading,
  subheading,
  seoHeadLevel,
  view_all_link,
  trailing,
}: StoresCarouselHeaderProps & { trailing: React.ReactNode }) => (
  <CarouselSection.Header
    title={{
      content: heading ?? 'Stores near you',
      isHidden: !heading,
      renderAs: getHeadingElement(seoHeadLevel),
    }}
    description={subheading ? <Body as="span">{subheading}</Body> : undefined}
    trailing={view_all_link ? trailing : undefined}
  />
)

export const StoresCarouselMobileHeader = (props: StoresCarouselHeaderProps) => (
  <StoresCarouselHeader {...props} trailing={<ViewAllIcon onClick={props.handleViewAll} />} />
)
